module.exports = __webpack_public_path__ + "img/bot_bdsh1.665497b4.png";